import entityReducer from "./dealSetupEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
